import util from '../util';
/**
 * 雨量グラフの表示
 */
export default class detail_uryo_graph_img {
    /**
     * コンストラクタ
     */
    constructor(mapPos) {
        this._uryoPoint = "";
        if (mapPos && mapPos.uryo_point) {
            this.dispGraph(mapPos.uryo_point);
        }
    }
    /**
     * 再描画
     */
    reflash() {
        this.dispGraph(this._uryoPoint);
    }
    /**
     * 雨量グラフの表示
     * @param uryoPoint
     */
    dispGraph(uryoPoint) {
        this._uryoPoint = uryoPoint;
        //  画像の表示
        let element = document.getElementById('detail_uryo_graph_img');
        //  画像ファイルのURL（クエリストリングはキャッシュ回避策）
        element.src = util.getPath(dosya_1kmesh_env.uryo_graph_img_path.replace("{0}", ("000" + uryoPoint.toString()).slice(-4))) + "?k=" + Date.now();
        element.hidden = false;
        if (!util.isSp) {
            //  画像クリック時イベント
            element.onclick = (e) => {
                const url = `./detail_uryo_graph.html?ccd=${uryoPoint}`;
                window.open(url, '', 'width=1050, height=800, resizable, scrollbars, location=no');
            };
        }
    }
}
